import { BaseApi } from '@/helpers/base-api'

export default class AppointmentRecurrenceApi extends BaseApi {
  constructor () {
    super('/api/v1/appointments-recurrences')
    this.errorMessage = 'There was an issue when trying to fetch the appointments-recurrences. If this error persists, please contact our support.'
  }

  public getAppointmentRecurrencesById = (recurrenceId: string): Promise<InstallationDto[]> => this.instance.get(`/${recurrenceId}`)

  public createAppointmentRecurrenceException = (data: Record<string, unknown>): Promise<JSON> => this.instance.post(`/${data.recurrence_id}/exceptions`, data);
  public deleteAppointmentRecurrenceOccurrence = (data: Record<string, unknown>): Promise<JSON> => this.instance.post(`/exceptions/${data.recurrence_id}/occurrence`, data);
  public endRecurringAppointment = (recurrenceId: string, data: Record<string, unknown>): Promise<JSON> => this.instance.patch(`/${data.recurrence_id}/end`, data);
  public updateAppointmentRecurrenceSeries = (recurrenceId: string, data: Record<string, unknown>): Promise<JSON> => this.instance.patch(`/${recurrenceId}`, data);
  public deleteAppointmentRecurrenceSeries = (recurrenceId: string): Promise<JSON> => this.instance.delete(`/${recurrenceId}`);

}
